import { axInstBasic } from "../../components/Service/Service";

export const getArnPayload = (parArn, childArn, selectedYear) => {
  const key = childArn ? "childArn" : "parArn";
  const value = childArn || parArn;

  // ✅ Build a single object with both ARN and year
  const payload = {
    [key]: value,
  };

  if (selectedYear) {
    payload.selectedYear = selectedYear;
  }

  return payload;
};

export const stateListComplaints = async (
  parArn,
  childArn,
  complaintsPayload
) => {
  try {
    const arnPayload = getArnPayload(parArn, childArn);

    const values = {
      ...arnPayload,
      ...complaintsPayload,
    };
    // console.log("Values", values)
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}stateList-Complaints`,
      values
    );

    // console.log(
    //   "API response (stateList-Complaints):",
    //   res.data
    // );
    return res.data.result;
  } catch (error) {
    console.error("Error fetching stateList-Complaints:", error);
    throw error;
  }
};

export const problemAreaListComplaints = async (
  parArn,
  childArn,
  complaintsPayload
) => {
  try {
    const arnPayload = getArnPayload(parArn, childArn);

    const values = {
      ...arnPayload,
      ...complaintsPayload,
    };

    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}problemAreaList-Complaints`,
      values
    );

    // console.log(
    //   "API response (problemAreaList-Complaints):",
    //   res.data
    // );
    return res.data.result;
  } catch (error) {
    console.error("Error fetching problemAreaList-Complaints:", error);
    throw error;
  }
};

export const primaryAreaWiseComplaintsData = async (
  parArn,
  childArn,
  complaintsPayload
) => {
  try {
    const arnPayload = getArnPayload(parArn, childArn);

    const values = {
      ...arnPayload,
      ...complaintsPayload,
    };

    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}primaryAreaWise-ComplaintsData`,
      values
    );
    return res.data.result;
  } catch (error) {
    console.error("Error fetching problemAreaList-Complaints:", error);
    throw error;
  }
};

export const yearListComplaints = async (
  parArn,
  childArn,
  complaintsPayload
) => {
  try {
    const arnPayload = getArnPayload(parArn, childArn);

    const values = {
      ...arnPayload,
      ...complaintsPayload,
    };

    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}yearList-Complaints`,
      values
    );

    // console.log(
    //   "API response (yearList-Complaints):",
    //   res.data
    // );
    return res.data.result;
  } catch (error) {
    console.error("Error fetching yearList-Complaints:", error);
    throw error;
  }
};

export const lobListComplaints = async (
  parArn,
  childArn,
  complaintsPayload
) => {
  try {
    const arnPayload = getArnPayload(parArn, childArn);

    const values = {
      ...arnPayload,
      ...complaintsPayload,
    };

    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}lobList-Complaints`,
      values
    );

    // console.log(
    //   "API response (lobList-Complaints):",
    //   res.data
    // );
    return res.data.result;
  } catch (error) {
    console.error("Error fetching lobList-Complaints:", error);
    throw error;
  }
};

export const pplListComplaints = async (
  parArn,
  childArn,
  complaintsPayload
) => {
  try {
    const arnPayload = getArnPayload(parArn, childArn);

    const values = {
      ...arnPayload,
      ...complaintsPayload,
    };

    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}pplList-Complaints`,
      values
    );

    // console.log(
    //   "API response (pplList-Complaints):",
    //   res.data
    // );
    return res.data.result;
  } catch (error) {
    console.error("Error fetching pplList-Complaints:", error);
    throw error;
  }
};

export const plListComplaints = async (parArn, childArn, complaintsPayload) => {
  try {
    const arnPayload = getArnPayload(parArn, childArn);

    const values = {
      ...arnPayload,
      ...complaintsPayload,
    };

    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}plList-Complaints`,
      values
    );

    // console.log(
    //   "API response (plList-Complaints):",
    //   res.data
    // );
    return res.data.result;
  } catch (error) {
    console.error("Error fetching plList-Complaints:", error);
    throw error;
  }
};

// Other API'S

export const totalComplaints = async (parArn, childArn, complaintsPayload) => {
  try {
    const arnPayload = getArnPayload(parArn, childArn);

    const values = {
      ...arnPayload,
      ...complaintsPayload,
    };

    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}total-complaints`,
      values
    );

    // console.log(
    //   "API response (total-complaints):",
    //   res.data
    // );
    return res.data.result;
  } catch (error) {
    console.error("Error fetching total-complaints:", error);
    throw error;
  }
};

export const totalComplaintsAvgTat = async (
  parArn,
  childArn,
  complaintsPayload
) => {
  try {
    const arnPayload = getArnPayload(parArn, childArn);

    const values = {
      ...arnPayload,
      ...complaintsPayload,
    };

    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}totalComplaints-AvgTat`,
      values
    );

    // console.log(
    //   "API response (totalComplaints-AvgTat):",
    //   res.data
    // );
    return res.data.result;
  } catch (error) {
    console.error("Error fetching totalComplaints-AvgTat:", error);
    throw error;
  }
};

export const stateGraphData = async (parArn, childArn, complaintsPayload) => {
  try {
    const arnPayload = getArnPayload(parArn, childArn);

    const values = {
      ...arnPayload,
      ...complaintsPayload,
    };

    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}state-GraphData`,
      values
    );

    // console.log(
    //   "API response (state-GraphData):",
    //   res.data
    // );
    return res.data.result;
  } catch (error) {
    console.error("Error fetching state-GraphData:", error);
    throw error;
  }
};

export const monthWiseGraphData = async (
  parArn,
  childArn,
  complaintsPayload
) => {
  try {
    const arnPayload = getArnPayload(parArn, childArn);

    const values = {
      ...arnPayload,
      ...complaintsPayload,
    };

    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}monthWiseGraphData`,
      values
    );

    // console.log(
    //   "API response (monthWiseGraphData):",
    //   res.data
    // );
    return res.data.result;
  } catch (error) {
    console.error("Error fetching monthWiseGraphData:", error);
    throw error;
  }
};

export const problemAreaWiseTableData = async (
  parArn,
  childArn,
  complaintsPayload
) => {
  try {
    const arnPayload = getArnPayload(parArn, childArn);

    const values = {
      ...arnPayload,
      ...complaintsPayload,
    };

    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}problemAreaWise-TableData`,
      values
    );

    // console.log(
    //   "API response (problemAreaWise-TableData):",
    //   res.data
    // );
    return res.data.result;
  } catch (error) {
    console.error("Error fetching problemAreaWise-TableData:", error);
    throw error;
  }
};

export const divisionWiseTableData = async (
  parArn,
  childArn,
  complaintsPayload
) => {
  try {
    const arnPayload = getArnPayload(parArn, childArn);

    const values = {
      ...arnPayload,
      ...complaintsPayload,
    };

    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}divisionWise-TableData`,
      values
    );

    // console.log(
    //   "API response (divisionWise-TableData):",
    //   res.data
    // );
    return res.data.result;
  } catch (error) {
    console.error("Error fetching divisionWise-TableData:", error);
    throw error;
  }
};

export const problemAreaTableData = async (
  parArn,
  childArn,
  complaintsPayload
) => {
  try {
    const arnPayload = getArnPayload(parArn, childArn);

    const values = {
      ...arnPayload,
      ...complaintsPayload,
    };

    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}problemArea-TableData`,
      values
    );

    // console.log(
    //   "API response (problemArea-TableData):",
    //   res.data
    // );
    return res.data.result;
  } catch (error) {
    console.error("Error fetching problemArea-TableData:", error);
    throw error;
  }
};

export const lobPplPlTableData = async (
  parArn,
  childArn,
  complaintsPayload
) => {
  try {
    const arnPayload = getArnPayload(parArn, childArn);

    const values = {
      ...arnPayload,
      ...complaintsPayload,
    };

    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}lobPplPl-TableData`,
      values
    );

    // console.log(
    //   "API response (lobPplPl-TableData):",
    //   res.data
    // );
    return res.data.result;
  } catch (error) {
    console.error("Error fetching lobPplPl-TableData:", error);
    throw error;
  }
};

export const getSalesComplaint = async (
  parArn,
  childArn,
  complaintsPayload
) => {
  try {
    const arnPayload = getArnPayload(parArn, childArn);

    const values = {
      ...arnPayload,
      ...complaintsPayload,
    };

    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}salesComplaintsTAT`,
      values
    );

    // console.log(
    //   "API response (salesComplaintsTAT):",
    //   res.data
    // );
    return res?.data?.result;
  } catch (error) {
    console.error("Error fetching salesComplaintsTAT:", error);
    throw error;
  }
};

export const getSalesComplaintTATMonth = async (
  parArn,
  childArn,
  complaintsPayload,
  selectedYear = "2019-20"
) => {
  try {
    const arnPayload = getArnPayload(parArn, childArn);

    const values = {
      ...arnPayload,
      ...complaintsPayload,
      selectedYear
    };

    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}salesComplaintsTATMonth`,
      values
    );

    // console.log(
    //   "API response (salesComplaintsTAT):",
    //   res.data
    // );
    return res?.data?.result || [];
  } catch (error) {
    console.error("Error fetching salesComplaintsTAT:", error);
    throw error;
  }
};

export const getOpenSalesComplaints = async (
  parArn,
  childArn,
  complaintsPayload
) => {
  try {
    const arnPayload = getArnPayload(parArn, childArn);

    const values = {
      ...arnPayload,
      ...complaintsPayload,
    };

    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}openSalesComplaints`,
      values
    );

    return res.data.result;
  } catch (error) {
    console.error("Error fetching salesComplaintsTAT:", error);
    throw error;
  }
};

export const getReopenedSalesComplaints = async (
  parArn,
  childArn,
  complaintsPayload
) => {
  try {
    const arnPayload = getArnPayload(parArn, childArn);

    const values = {
      ...arnPayload,
      ...complaintsPayload,
    };

    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}reopenedSalesComplaints`,
      values
    );

    return res.data.result;
  } catch (error) {
    console.error("Error fetching salesComplaintsTAT:", error);
    throw error;
  }
};
